export const TEST_IDS = {
  // nav
  navLogo: 'nav-logo-link',
  navHome: 'nav-link-home',
  navListen: 'nav-link-listen',
  navSchedule: 'nav-link-schedule',
  navShows: 'nav-link-shows',
  navAlexa: 'nav-link-alexa',
  navAbout: 'nav-link-about',
  navContact: 'nav-link-contact',
  navMenuToggle: 'nav-menu-toggle',
  // player
  playerToggle: 'player-toggle-btn',
  playerVolume: 'player-volume-slider',
  playerSongTitle: 'player-song-title',
  playerListeners: 'player-listeners',
  playerLiveDot: 'player-live-indicator',
  // home
  homeHeroPlay: 'home-hero-play-btn',
  homeTagline: 'home-tagline',
  // listen
  listenStreamUrl: 'listen-stream-url',
  // alexa
  alexaInvocation: 'alexa-invocation-name',
  alexaCopyEndpoint: 'alexa-copy-endpoint-btn',
  alexaCopyStream: 'alexa-copy-stream-btn',
  // contact
  contactName: 'contact-input-name',
  contactEmail: 'contact-input-email',
  contactSubject: 'contact-input-subject',
  contactMessage: 'contact-input-message',
  contactSubmit: 'contact-submit-btn',
  contactSuccess: 'contact-success-msg',
  contactError: 'contact-error-msg',
};
